import React, { Fragment } from 'react';
import Card from './Card';
import Header from './Header';

const Users = () => (
    <Fragment>
        <Header />
        <div className="container-fluid mt--6">
            <div className="row">
                <div className="col">
                    <Card />
                </div>
            </div>
        </div>
    </Fragment>
);

export default Users;


// WEBPACK FOOTER //
// ./src/components/Pages/Users/index.js